/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Info } from '../../core/models/common/Info';

/**
 * Constructor.
 * @class
 * @extends Info
 * @author eric.wittmann@gmail.com
 */
export abstract class OasInfo extends Info {
    public constructor() {
        super();
    }
}
OasInfo["__class"] = "io.apicurio.datamodels.openapi.models.OasInfo";
OasInfo["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




